export { default } from './SnapdocsClosingBlock';
